import React from 'react';
import { connect } from 'react-redux';
import { Link, Route, Routes } from 'react-router-dom';
import { Menu, Layout, Spin } from 'antd';
import type { MenuProps } from 'antd';
import { withTranslation, WithTranslation } from 'react-i18next';
import { ApplicationState } from '../../reducers';
import { withReceiverRouteWrapper } from '../ReceiverRouteWrapper';
import { fetchExternalSources } from '../../actions/receiver_data_stream/externalSources/fetch';
import { ExternalSources } from '../../../types/external_sources';
import ExternalSourcePage from '../../components/body/external_sources/ExternalSourcePage';
import ExternalSourceImportLogs from '../../components/body/external_sources/ExternalSourceImportLogs';
import { WithRouterProps, withRouter } from '../withRouter';

const { Content, Sider } = Layout;

type MenuItem = Required<MenuProps>['items'][number];

type ExternalSourcesContainerProps = {
  dispatch: any;
  externalSources: ExternalSources;
  fetchingSources: boolean;
};

type Props = ExternalSourcesContainerProps & WithRouterProps & WithTranslation;
class ExternalSourcesContainer extends React.Component<Props> {
  componentDidMount() {
    this.props.dispatch(fetchExternalSources());
  }

  render() {
    const { t, location, fetchingSources, externalSources } = this.props;
    const sourceItems: MenuItem[] = [
      {
        key: '/available-brands/external-sources/sdc',
        label: <Link to={{ pathname: `sdc` }}>{t('externalSources:sdc')}</Link>,
      },
      {
        key: '/available-brands/external-sources/dci',
        label: <Link to={{ pathname: `dci` }}>{t('externalSources:dci')}</Link>,
      },
      {
        key: '/available-brands/external-sources/asap',
        label: <Link to={{ pathname: `asap` }}>{t('externalSources:asap')}</Link>,
      },
      {
        key: '/available-brands/external-sources/opticat',
        label: <Link to={{ pathname: `opticat` }}>{t('externalSources:opticat')}</Link>,
      },
      {
        key: '/available-brands/external-sources/import-logs',
        label: <Link to={{ pathname: `import-logs` }}>{t('externalSources:importReports')}</Link>,
      },
    ];

    return (
      <Layout className="layout">
        <Sider theme="light">
          <Menu
            mode="inline"
            defaultSelectedKeys={['1']}
            selectedKeys={[location.pathname]}
            items={sourceItems}
          />
        </Sider>
        <Content className="main-page-content">
          {fetchingSources || !externalSources?.sdc ? (
            <Spin className="spinner-center" />
          ) : (
            <Routes>
              <Route path="sdc" element={<ExternalSourcePage />} />
              <Route path="dci" element={<ExternalSourcePage />} />
              <Route path="asap" element={<ExternalSourcePage />} />
              <Route path="opticat" element={<ExternalSourcePage />} />
              <Route path="import-logs" element={<ExternalSourceImportLogs />} />
            </Routes>
          )}
        </Content>
      </Layout>
    );
  }
}

const mapStateToProps = (state: ApplicationState) => {
  return {
    externalSources: state.externalSources.externalSources,
    fetchingSources: state.externalSources.fetchingSources,
  };
};

export default connect(mapStateToProps)(
  withRouter(withReceiverRouteWrapper(withTranslation()(ExternalSourcesContainer)))
);
